import React from 'react';


export const Faust = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/faust.png')} />
    )
};
